import { TYPELAYER} from './TypeLayerTypes'
const initialState = {
    typeLayer: "WMS"
}

const changeTypeLayer = (state = initialState, action) => {
    
    switch (action.type) {
        case TYPELAYER:
            
            return {
                typeLayer: action.load
            }
    
        default:
          return state
    }

}


export default changeTypeLayer;